export const FIELD_LABEL_CLASS =
  'text-xs font-medium text-muted-foreground data-[error=true]:text-destructive';

export const FULL_ROW_FIELD_CLASS = '@sm:col-span-full';

export const LEADING_SYMBOL_CLASS =
  'pointer-events-none absolute inset-y-0 left-3 flex items-center text-sm text-muted-foreground';
